import { render, staticRenderFns } from "./NormalMathButton.vue?vue&type=template&id=ca01bbb0&"
import script from "./NormalMathButton.vue?vue&type=script&lang=js&"
export * from "./NormalMathButton.vue?vue&type=script&lang=js&"
import style0 from "./NormalMathButton.vue?vue&type=style&index=0&id=ca01bbb0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports